/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HorecaReceptionBellIcon16Light } from './HorecaReceptionBellIcon16Light';
import { HorecaReceptionBellIcon16Regular } from './HorecaReceptionBellIcon16Regular';
import { HorecaReceptionBellIcon16Solid } from './HorecaReceptionBellIcon16Solid';
import { HorecaReceptionBellIcon20Light } from './HorecaReceptionBellIcon20Light';
import { HorecaReceptionBellIcon20Regular } from './HorecaReceptionBellIcon20Regular';
import { HorecaReceptionBellIcon20Solid } from './HorecaReceptionBellIcon20Solid';
import { HorecaReceptionBellIcon24Regular } from './HorecaReceptionBellIcon24Regular';
import { HorecaReceptionBellIcon24Solid } from './HorecaReceptionBellIcon24Solid';
import { HorecaReceptionBellIcon32Regular } from './HorecaReceptionBellIcon32Regular';
import { HorecaReceptionBellIcon64Regular } from './HorecaReceptionBellIcon64Regular';
var sizes = {
    16: {
        light: HorecaReceptionBellIcon16Light,
        regular: HorecaReceptionBellIcon16Regular,
        solid: HorecaReceptionBellIcon16Solid,
    },
    20: {
        light: HorecaReceptionBellIcon20Light,
        regular: HorecaReceptionBellIcon20Regular,
        solid: HorecaReceptionBellIcon20Solid,
    },
    24: {
        regular: HorecaReceptionBellIcon24Regular,
        solid: HorecaReceptionBellIcon24Solid,
    },
    32: {
        regular: HorecaReceptionBellIcon32Regular,
    },
    64: {
        regular: HorecaReceptionBellIcon64Regular,
    },
};
export var HorecaReceptionBellIcon = forwardRef('HorecaReceptionBellIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
